export const EmptyGuid: string = '00000000-0000-0000-0000-000000000000';
export const PendingAcRegistrationProcessesStatusId: string = '1ee61969-34d9-ed11-a9cf-6045bd8abf6c';
export const LinkDevAccountGuid: string = 'b356a132-afea-ea11-aa74-936f9088d9f3';

export const AocErrorMessage: string =
    `You shall have an AOC with status “Active” or "In progress" before Applying for this request.`;

export const DraftStatus: string = 'B2CB511C-CAD3-E911-A9CF-000D3A258246'.toLowerCase();
export const PendingAocMainDocumentsStatusId: string = 'A37AEB6B-0F4E-EE11-AAD3-6045BD8ABF6C'.toLowerCase();
export const PendingOnApplicantStatusId: string = 'A3CAB2F5-55F2-ED11-AA02-6045BD8ABF6C'.toLowerCase();
export const PendingACsRegistrationProcessesStatusId: string = '39A0F250-0F4E-EE11-AAD3-6045BD8ABF6C'.toLowerCase();

export const GaocServiceId: string = '0290CA3D-D94B-EE11-AACF-6045BD8ABF6C'.toLowerCase();
export const ServiceEntityContractName: string = 'Service';
export const ServiceEntityLogicalName: string = 'ldv_service';

export const GaocServiceName: string = 'Grant Aoc Service';

export const GaocEntityLogicalName: string = 'ldv_grantaocservicerequest';
export const AirOperatorCertificateLogicalName: string = 'ldv_airoperatorcertificate';
export const GaocContractName: string = 'GrantAocServiceRequest';
export const GaocModelName: string = 'GrantAocServiceRequest.GaocRequest';
export const AocModelName: string = 'AirOperatorCertificate';
export const AocDocumentReviewModelName: string = 'GrantAocServiceRequest.AocDocumentsReview';

export const AocDocumentReviewLogicalName: string = 'ldv_aocdocumentreviewsubprocess';
export const AocDocumentReviewContractName: string = 'AocDocumentReviewSubProcess';

export const BahrainNationalityId: string = '25c9ff9b-1c03-eb11-aa6f-bebfb44b612b';

export const InvitationLinkSuccessMessageHeader: string = "A verification link has been sent to your email account";
export const InvitationLinkFailureMessageHeader: string = "Failed to send the verification email";
export const InvitationLinkFailureMessageBody: string = "please try again";
export const InvitationLinkSuccessMessageBody: string = "Please click on the link that has just been sent to your email "
    + "account to verify your email";